// Matches the enum name at the start of a package limit error, e.g.
// "PACKAGE_WEIGHT_EXCEEDS_LIMIT of 3000g for STANDARD SMALL". Shipments
// validated before the server switched to customer wording still carry the
// enum name in errors.packages[].errors.limits[].code, and it must never be
// shown on screen. Mirrors server/src/utils/packageLimitErrorMessage.ts so
// old rows read exactly like new ones.
const PACKAGE_LIMIT_CODE_PATTERN = /^PACKAGE_[A-Z_]+_EXCEEDS_LIMIT\b/;

const toSentence = (code: string): string => {
  const words = code.toLowerCase().split("_").join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const humanisePackageLimitError = <T>(code: T): T | string => {
  if (typeof code !== "string" || !PACKAGE_LIMIT_CODE_PATTERN.test(code)) {
    return code;
  }

  return code
    .replace(PACKAGE_LIMIT_CODE_PATTERN, toSentence)
    .replace(/\s{2,}/g, " ")
    .trim();
};
